export { resolveComponentVersion } from '@json-to-office/shared/plugin';
